import { getRouteApi, Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import { safeRedirect, useDocumentTitle } from '@/shared/lib'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/shared/ui'

import { RegisterForm } from '../components/register-form'

import '../i18n'

// Read through the route API so the feature imports nothing from `src/routes/`.
const route = getRouteApi('/_public/register')

export function RegisterPage() {
  const { t } = useTranslation(['auth', 'common'])
  const { returnTo } = route.useSearch()

  // Same reason as the sign-in page: a `CardTitle` heads this screen, so the
  // title has to be set here or the tab keeps the bare product name.
  useDocumentTitle(t('auth:register.title'))

  return (
    <Card className="w-modal-confirm max-w-full">
      <CardHeader>
        <CardTitle>{t('auth:register.title')}</CardTitle>
        <CardDescription>{t('auth:register.description')}</CardDescription>
      </CardHeader>

      <CardContent className="flex flex-col gap-5">
        {/* Absolute URLs are rejected here, not after sign-up — otherwise this
            is an open redirect. */}
        <RegisterForm returnTo={safeRedirect(returnTo)} />

        <p className="text-caption text-muted-foreground">
          {t('auth:register.haveAccount')}{' '}
          <Link to="/login" className="text-foreground underline underline-offset-4">
            {t('auth:register.signIn')}
          </Link>
        </p>
      </CardContent>
    </Card>
  )
}
